import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector'; // Optional: Detect browser language

i18n
    // Load translation using http -> see /public/locales
    .use(HttpApi)
    // Detect user language
    // .use(LanguageDetector) // Uncomment this if you want browser language detection
    // Pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // Init i18next
    .init({
        lng: 'en', // Force English as default language
        supportedLngs: ['en', 'hr'],
        fallbackLng: 'en', // Use English if detected language is not available
        debug: false, // Disabled - translations are working

        // Specify where backend should find translations
        backend: {
            loadPath: '/locales/{{lng}}/translation.json?v=' + new Date().getTime(), // Path to translation files with cache busting
        },

        // React-specific configuration
        react: {
            useSuspense: false, // Set to true if using React.Suspense for loading translations
        },

        interpolation: {
            escapeValue: false, // React already safes from xss
        },

        // Configuration for LanguageDetector (optional)
        // detection: {
        //   order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        //   caches: ['localStorage'],
        // },
    });

export default i18n; 